import "core-js/modules/es.array.push.js";
import Bus from '@/assets/js/bus.js';
import { mapState } from 'vuex';
export default {
  props: {
    isallScrren: {
      type: Boolean,
      default: false
    },
    anywherePopShow: {
      type: Object,
      default: function () {
        return {};
      }
    },
    packagedDeviceType: {
      type: Object,
      default: function () {
        return {};
      }
    },
    shareList: Object,
    currentTypeShare: String,
    devicePlatform: {
      type: Object,
      default: function () {
        return {};
      }
    },
    deviceType: {
      type: Object,
      default: function () {
        return {};
      }
    },
    degreeHost: {
      type: Object,
      default: function () {
        return {};
      }
    },
    rtilList: Array,
    behaviorInfo: Object,
    userInfo: Object,
    streamInfo: Object,
    outputRtilList: Array,
    showMuteIcons: {
      type: Boolean,
      default: true
    },
    showChatMessage: Boolean,
    allRList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    extraChannel: {
      type: Object,
      default: () => {
        return {};
      }
    },
    fullScreen: Boolean,
    uploadLogo: Boolean,
    outputRtilCode: {
      default: ''
    },
    outputSourceType: String,
    rtc: Object,
    host: String,
    tagNameInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    remoteNetWorks: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showPipCursorPointer: {
      type: Boolean,
      default: false
    },
    isAudioLevel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      logoGray: state => state.logoGray
    }),
    onlyMainWindow() {
      if (this.rtilList.length == 1 && (this.outputRtilCode == this.rtilList[0] || this.rtilList[0] == 'mainWindow')) {
        return true;
      } else {
        return false;
      }
    },
    isMainWindow() {
      var obj = {};
      if (this.outputSourceType == 'Pbp') {
        this.outputRtilList.forEach(val => {
          if (this.rtilList.includes(val.rtilCode)) {
            obj[val.rtilCode] = true;
          }
        });
      } else {
        this.rtilList.forEach(val => {
          if (val == 'mainWindow' || val == this.outputRtilCode) {
            obj[val] = true;
          }
        });
      }
      return obj;
    },
    operateList() {
      const obj = {};
      this.rtilList.forEach(rtilCode => {
        obj[rtilCode] = [];
        if (this.State.crewInfo.rtilCode == this.userInfo.rtilCode) {
          if (this.State.privateInfo.rtilCode == rtilCode) {
            obj[rtilCode] = ['cancelPrivateConversation', 'moveParty'];
          } else {
            obj[rtilCode] = ['startPrivateConversation', 'moveParty'];
          }
        }
        if (this.host) {
          obj[rtilCode].unshift('rename', 'editTagName');
          obj[rtilCode].push('removeParticipant');
          this.outputRtilList.forEach(item => {
            if (item.rtilCode == rtilCode) {
              obj[rtilCode] = obj[rtilCode].filter(val => {
                val != 'moveParty';
              });
            }
          });
        }
        // 只有在与会者打开摄像头时候，Host页面才显示全屏操作，并且全屏操作放在首位
        if (this.State.cameraStatus[rtilCode]) {
          obj[rtilCode].unshift('fullScreen');
        }
        if (this.host && this.$route.name == 'kiosk') {
          obj[rtilCode].unshift('SetTag');
        }
        // 移除anyWhere中的setting
        if (this.packagedDeviceType[rtilCode] == 'App' || this.packagedDeviceType[rtilCode] == 'Anywhere') {
          obj[rtilCode].push('anyWhereSetting');
        }
        if (this.host && this.$route.name == 'kiosk' && this.State.partyTag == rtilCode) {
          obj[rtilCode].shift();
          obj[rtilCode].unshift('CancelTag');
        }
      });
      return obj;
    },
    showMoveIcon() {
      return this.State.batchMoveParticipate;
    },
    pbpNoSourceText() {
      const obj = {};
      this.outputRtilList.forEach(val => {
        obj[val.rtilCode] = this.pbpSourceText[val.position];
      });
      return obj;
    }
  },
  watch: {
    allRList(val) {
      if (!this.allRList) return;
      this.formatRList(this.allRList, true);
    },
    'rtilList.length': {
      handler: function (val) {
        if (!val) return;
        if (this.outputSourceType == 'Pbp') {
          this.changePbpView(val);
          this.$nextTick(() => {
            if (this.State.isVertical) {
              this.changeVerticalCanvas();
            } else {
              this.changeCanvasView();
            }
          });
        } else {
          if (this.State.isVertical) {
            this.changeVerticalVal(val);
          } else {
            this.changeView(val);
          }
          this.setItemGridWidth(this.row, this.column, this.offsetMainWindowY, this.offsetMainWindowX, this.spanMainWindowY, this.spanMainWindowX);
          this.$nextTick(() => {
            if (this.State.isVertical) {
              this.changeVerticalCanvas();
            } else {
              this.changeCanvasView();
            }
          });
        }
        // for (var i = 0; i < (26 - val); i++) {
        //   this.rtilList.unshift(i)
        // }
      },

      immediate: true
    },
    outputSourceType(val) {
      if (val == 'Pbp') {
        this.changePbpView(this.rtilList.length);
        this.$nextTick(() => {
          if (this.State.isVertical) {
            this.changeVerticalCanvas();
          } else {
            this.changeCanvasView();
          }
        });
      } else {
        if (this.State.isVertical) {
          this.changeVerticalVal(this.rtilList.length);
        } else {
          this.changeView(this.rtilList.length);
        }
        this.setItemGridWidth(this.row, this.column, this.offsetMainWindowY, this.offsetMainWindowX, this.spanMainWindowY, this.spanMainWindowX);
        this.$nextTick(() => {
          if (this.State.isVertical) {
            this.changeVerticalCanvas();
          } else {
            this.changeCanvasView();
          }
        });
      }
    },
    fullScreen(val) {
      setTimeout(() => {
        if (this.State.isVertical) {
          this.changeVerticalCanvas();
        } else {
          this.changeCanvasView();
        }
      }, 200);
    },
    uploadLogo(val) {
      setTimeout(() => {
        if (this.State.isVertical) {
          this.changeVerticalCanvas();
        } else {
          this.changeCanvasView();
        }
      }, 200);
    },
    'State.batchMoveParticipate'(val) {
      if (!val) {
        // 清空上一次所选择的与会者
        this.movePips = {};
      }
    },
    // 刷新保持global全屏
    'State.globalisFullScreen'(val) {
      if (val === 1) {
        this.isFullScreen = true;
        this.State.isWebFullScreen = true;
      } else {
        this.isFullScreen = false;
        this.State.isWebFullScreen = false;
      }
    }
  },
  data() {
    return {
      lowNetworkTime: 0,
      lowNetwork: false,
      initAudioOnlyPopup: true,
      setTag: '',
      isFullScreen: false,
      getReceiverParams: '',
      getRListTimer: null,
      receiverList: [],
      listNum: 13,
      layoutStyle: {
        'grid-template-columns': 'repeat(2, 50%)' // 从第一行开始到第几行设置宽度为15%
      },

      mainWindowPosition: {
        'grid-column': '1 / span 2',
        'grid-row': '1 / span 2'
      },
      mainWindowPositionList: {},
      column: 2,
      row: 3,
      voiceList: {},
      rtilStatusObj: {},
      movePips: {},
      pbpSourceText: {
        1: 'Left Main Window',
        2: 'Right Main Window'
      },
      offsetMainWindowX: null,
      offsetMainWindowY: null,
      spanMainWindowY: null,
      spanMainWindowX: null
    };
  },
  created() {
    this.keyDown();
    if (this.allRList) {
      if (!this.allRList) return;
      this.formatRList(this.allRList, true);
    }
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach((volume, index) => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$on('startPrivateConversation', v => {
      this.State.privateInfo = v;
    });
    Bus.$on('cancelPrivateConversation', v => {
      this.State.privateInfo = {};
    });
    Bus.$on('rtilLiveStatus', v => {
      this.rtilStatusObj = v;
    });
    Bus.$on('selectAllPipMove', v => {
      // 只对目前已有的与会者进行操作，后加入的不处理
      if (v.type === 'all') {
        let movePipLists = Object.keys(this.operateList).filter(v => v !== 'mainWindow');
        // 去掉主屏的rtilCode
        if (this.outputRtilCode) {
          movePipLists = movePipLists.filter(v => v != this.outputRtilCode);
        }
        movePipLists.forEach(id => {
          if (this.operateList[id].includes('moveParty')) {
            this.$set(this.movePips, id, v.status);
          }
          this.$emit('callback', {
            type: 'moveParty',
            id: id,
            status: v.status,
            sign: 'batch'
          });
        });
      }
    });
    // audioOnly选择器
    Bus.$on('subscribeAudioControl', val => {
      if (val) {
        // 2 禁用
        if (val == 2) {
          Object.keys(this.streamInfo).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && this.streamInfo[rtilCode].hasUnsubscribe) {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video', 'unExecuteCallback');
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
              this.streamInfo[rtilCode].hasUnsubscribe = false;
            }
          });
          return; // 2 是关闭 audio-only 状态不用订阅
        }
        // 1 allTheTime
        Object.keys(this.streamInfo).forEach(rtilCode => {
          if (rtilCode != this.userInfo.rtilCode && !this.streamInfo[rtilCode].hasUnsubscribe) {
            // 需要判断当前的 mainWindow 和 shareScreen 是否处于选中状态，选中需要订阅
            if (this.outputRtilCode == rtilCode) {
              if (!this.State.checkMainWindow) {
                if (this.State.checkShareScreen && this.currentTypeShare == 'mainWindow') return;
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(rtilCode, 'video');
                this.$set(this.streamInfo[rtilCode], 'hasUnsubscribe', true);
              }
            } else if (this.shareList[rtilCode]) {
              if (!this.State.checkShareScreen) {
                if (this.currentTypeShare == 'pip') {
                  if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
                } else {
                  if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(rtilCode, 'video');
                }
                this.$set(this.streamInfo[rtilCode], 'hasUnsubscribe', true);
              }
            } else {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].unsubscribe(rtilCode, 'video');
              this.$set(this.streamInfo[rtilCode], 'hasUnsubscribe', true);
            }
          }
        });
      } else {
        // 0 自动
        Object.keys(this.streamInfo).forEach(rtilCode => {
          if (rtilCode != this.userInfo.rtilCode && this.streamInfo[rtilCode].hasUnsubscribe) {
            // 需要判断当前的 mainWindow 和 shareScreen 是否处于选中状态，选中需要订阅
            if (this.outputRtilCode == rtilCode) {
              // 分为两种情况一种网络较好(可以不取参考checkbox)，另外一种是网络不好需要参考checkbox
              if (!this.State.inAudioOnlyStatus) {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
                this.streamInfo[rtilCode].hasUnsubscribe = false;
              } else {
                if (this.State.checkMainWindow) {
                  if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
                  this.streamInfo[rtilCode].hasUnsubscribe = false;
                }
              }
            } else if (this.shareList[rtilCode]) {
              if (!this.State.inAudioOnlyStatus) {
                if (this.currentTypeShare == 'pip') {
                  if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video', 'unExecuteCallback');
                } else {
                  if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
                }
                this.streamInfo[rtilCode].hasUnsubscribe = false;
              } else {
                if (this.State.checkShareScreen) {
                  if (this.currentTypeShare == 'pip') {
                    if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video', 'unExecuteCallback');
                  } else {
                    if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
                  }
                  this.streamInfo[rtilCode].hasUnsubscribe = false;
                }
              }
            } else {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video', 'unExecuteCallback');
              this.streamInfo[rtilCode].hasUnsubscribe = false;
            }
          }
        });
      }
    });
    // mainWindow 勾选
    Bus.$on('dealMainAudioOnly', val => {
      if (this.outputRtilCode) {
        // 先判断当前处于哪种模式下
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
            this.streamInfo[this.outputRtilCode].hasUnsubscribe = false;
          } else {
            if (val) {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
              this.streamInfo[this.outputRtilCode].hasUnsubscribe = false;
            } else {
              if (this.$route.name != 'kioskParticipate') {
                if (this.State.checkShareScreen && this.currentTypeShare == 'mainWindow') return;
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
                this.streamInfo[this.outputRtilCode].hasUnsubscribe = true;
              } else {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
                this.streamInfo[this.outputRtilCode].hasUnsubscribe = true;
              }
            }
          }
        } else {
          // 如果是 auto audio-only 需要先判断当前是否处于 audio-only 状态中
          if (!this.State.inAudioOnlyStatus) {
            if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
            this.streamInfo[this.outputRtilCode].hasUnsubscribe = false;
          } else {
            if (val) {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
              this.streamInfo[this.outputRtilCode].hasUnsubscribe = false;
            } else {
              if (!this.State.checkShareScreen) {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(this.outputRtilCode, 'video', 'unExecuteCallback');
                this.streamInfo[this.outputRtilCode].hasUnsubscribe = true;
              }
            }
          }
        }
      }
    });
    // shareScreen 勾选
    Bus.$on('dealShareAudioOnly', val => {
      Object.keys(this.shareList).forEach(rtilCode => {
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            if (this.currentTypeShare == 'pip') {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video', 'unExecuteCallback');
            } else {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
            }
            this.streamInfo[rtilCode].hasUnsubscribe = false;
          } else {
            if (val) {
              if (this.currentTypeShare == 'pip') {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video', 'unExecuteCallback');
              } else {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
              }
              this.streamInfo[rtilCode].hasUnsubscribe = false;
            } else {
              if (this.currentTypeShare == 'pip') {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
              } else {
                if (this.$route.name != 'kioskParticipate' && this.State.checkMainWindow) return;
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
              }
              this.streamInfo[rtilCode].hasUnsubscribe = true;
            }
          }
        } else {
          if (!this.State.inAudioOnlyStatus) {
            if (this.currentTypeShare == 'pip') {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video', 'unExecuteCallback');
            } else {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
            }
            this.streamInfo[rtilCode].hasUnsubscribe = false;
          } else {
            if (val) {
              if (this.currentTypeShare == 'pip') {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video', 'unExecuteCallback');
              } else {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video', 'unExecuteCallback');
              }
              this.streamInfo[rtilCode].hasUnsubscribe = false;
            } else {
              if (this.currentTypeShare == 'pip') {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
              } else {
                if (this.State.checkMainWindow) return;
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
              }
              this.streamInfo[rtilCode].hasUnsubscribe = true;
            }
          }
        }
      });
    });
    // 处理初始化及其他 audio-only 时的视频订阅问题
    Bus.$on('setSubscribeTrack', payload => {
      const _this = this;
      const {
        id
      } = payload;
      // 因为还没有后面赋值所以先添加上
      if (!this.streamInfo[id]) {
        this.$set(this.streamInfo, id, {
          id: id
        });
      }
      if (this.outputRtilCode && this.outputRtilCode == id) {
        // 先判断当前 audio-only 选择的模式
        if (this.State.audioType) {
          if (this.State.checkMainWindow || this.State.audioType == 2 || this.State.checkShareScreen && this.$route.name != 'kioskParticipate' && this.currentTypeShare == 'mainWindow') {
            this.streamInfo[id].hasUnsubscribe = false;
            if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(id, 'video', 'unExecuteCallback');
          } else {
            this.streamInfo[id].hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkMainWindow) {
              this.streamInfo[id].hasUnsubscribe = false;
              if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(id, 'video', 'unExecuteCallback');
            } else {
              this.streamInfo[id].hasUnsubscribe = true;
            }
          } else {
            this.streamInfo[id].hasUnsubscribe = false;
            if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(id, 'video', 'unExecuteCallback');
          }
        }
      } else if (this.shareList && this.$route.name == 'kioskParticipate') {
        if (this.State.audioType) {
          if (this.State.checkShareScreen || this.State.audioType == 2) {
            this.streamInfo[id].hasUnsubscribe = false;
            if (this.currentTypeShare == 'pip') {
              if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.realPartyCode].subscribe(id, 'video', 'unExecuteCallback');
            } else {
              if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(id, 'video', 'unExecuteCallback');
            }
          } else {
            this.streamInfo[id].hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkShareScreen) {
              this.streamInfo[id].hasUnsubscribe = false;
              if (this.currentTypeShare == 'pip') {
                if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.realPartyCode].subscribe(id, 'video', 'unExecuteCallback');
              } else {
                if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(id, 'video', 'unExecuteCallback');
              }
            } else {
              this.streamInfo[id].hasUnsubscribe = true;
            }
          } else {
            this.streamInfo[id].hasUnsubscribe = false;
            if (this.currentTypeShare == 'pip') {
              if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.realPartyCode].subscribe(id, 'video', 'unExecuteCallback');
            } else {
              if (!this.State.localShareInfo[id]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(id, 'video', 'unExecuteCallback');
            }
          }
        }
      } else {
        if (this.State.audioType == 1) {
          _this.streamInfo[id].hasUnsubscribe = true;
        } else {
          if (!this.State.localShareInfo[id]) _this.rtc[this.userInfo.realPartyCode].subscribe(id, 'video', 'unExecuteCallback');
          this.streamInfo[id].hasUnsubscribe = false;
        }
      }
    });
    // audioOnly自动网络质量变化的情况下
    Bus.$on('downlinkNetworkQuality', val => {
      // 判断当前所选择的 audio-only 模式，如果是 all time 的话则不需要走这段逻辑
      if (this.State.audioType || this.State.audioType == 2) return;
      // 当连续8s处于若网时，则改为只订阅音频流,连续6s状态良好则恢复订阅视频流
      if (val < 4) {
        if (this.lowNetworkTime > 0) {
          this.lowNetworkTime--;
        } else {
          this.lowNetworkTime = 0;
        }
        if (this.lowNetwork && this.lowNetworkTime === 0) {
          this.lowNetwork = false;
          Object.keys(this.streamInfo).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && this.streamInfo[rtilCode].hasUnsubscribe) {
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].subscribe(rtilCode, 'video');
              if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].subscribe(rtilCode, 'video');
              this.streamInfo[rtilCode].hasUnsubscribe = false;
            }
          });
          this.State.inAudioOnlyStatus = false;
          this.initAudioOnlyPopup = true;
        }
      } else {
        if (this.lowNetworkTime < 3) {
          this.lowNetworkTime++;
        } else if (this.lowNetworkTime === 3) {
          this.lowNetwork = true;
        }
        if (this.lowNetwork) {
          Object.keys(this.streamInfo).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && !this.streamInfo[rtilCode].hasUnsubscribe) {
              if (!(this.outputRtilCode == rtilCode && this.State.checkMainWindow) && !(this.shareList[rtilCode] && this.State.checkShareScreen) && this.$route.name != 'kioskParticipate') {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
                this.streamInfo[rtilCode].hasUnsubscribe = true;
              }
              // 处理与会者
              if (this.$route.name == 'kioskParticipate' && !this.State.checkMainWindow && this.outputRtilCode == rtilCode) {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.externalJoinInfo.join].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
                this.streamInfo[rtilCode].hasUnsubscribe = true;
              } else if (this.$route.name == 'kioskParticipate' && !this.State.checkShareScreen && this.outputRtilCode != rtilCode) {
                if (!this.State.localShareInfo[rtilCode]) this.rtc[this.userInfo.realPartyCode].unsubscribe(rtilCode, 'video', 'unExecuteCallback');
                this.streamInfo[rtilCode].hasUnsubscribe = true;
              }
            }
          });
          this.State.inAudioOnlyStatus = true;
          if (this.initAudioOnlyPopup) {
            this.initAudioOnlyPopup = false;
            this.$message.success(this.$t('netWorkStatus.poorNetworkPopup'));
          }
        }
      }
    });
  },
  beforeDestory() {
    this.keyDownReview();
  },
  methods: {
    updateTag(e) {
      this.setTag = e;
    },
    setPipUser() {
      // 与会者切换
      this.$nextTick(() => {
        this.rtilList.forEach(rtilCode => {
          if (this.$refs[`remoteSource${rtilCode}`] && !this.outputRtilCode && this.outputRtilCode != rtilCode) {
            this.$refs[`remoteSource${rtilCode}`][0] && this.$refs[`remoteSource${rtilCode}`][0].setSpeakerAttendUser();
          }
          if (this.$refs[`mainWindow${rtilCode}`] && this.outputRtilCode && this.outputRtilCode != rtilCode) {
            this.$refs[`mainWindow${rtilCode}`][0] && this.$refs[`mainWindow${rtilCode}`][0].setSpeakerAttendUser();
          }
        });
      });
    },
    // 按键恢复
    // keyDownReview () {
    //   document.onkeydown = function (event) {
    //     var e = event || window.event;
    //     e.returnValue = true;
    //   }
    // },
    // 按钮监听键盘
    keyDown() {
      // 监听键盘按钮(ESC)
      const _this = this;
      document.onkeydown = function (event) {
        var e = event || window.event;
        const keyCode = e.keyCode || e.which;
        if (keyCode === 27) {
          _this.isFullScreen = false;
          _this.State.isWebFullScreen = false;
          _this.State.globalisFullScreen = 0;
        }
      };
    },
    changeFullScreen(val) {
      if (val === 1) {
        this.isFullScreen = true;
        // 处理host上面的heade(隐藏)
        this.State.isWebFullScreen = true;
      } else {
        this.isFullScreen = false;
        this.State.isWebFullScreen = false;
      }
      this.$refs.mainWindow && this.$refs.mainWindow[0].changeFullRotate(val);
    },
    resizeUi(val) {
      if (val == 'Pbp') {
        this.changePbpView(this.rtilList.length);
        this.$nextTick(() => {
          if (this.State.isVertical) {
            this.changeVerticalCanvas();
          } else {
            this.changeCanvasView();
          }
        });
      } else {
        if (this.State.isVertical) {
          this.changeVerticalVal(this.rtilList.length);
        } else {
          this.changeView(this.rtilList.length);
        }
        this.setItemGridWidth(this.row, this.column, this.offsetMainWindowY, this.offsetMainWindowX, this.spanMainWindowY, this.spanMainWindowX);
        this.$nextTick(() => {
          if (this.State.isVertical) {
            this.changeVerticalCanvas();
          } else {
            this.changeCanvasView();
          }
        });
      }
    },
    formatRList(result, showSelect, page) {
      let array = [];
      result = JSON.parse(JSON.stringify(result));
      this.receiverList = [];
      this.State.slotList = [];
      // receiver list
      const receiverObj = {};
      receiverObj.value = 'Receiver';
      receiverObj.label = 'Receiver';
      receiverObj.children = [];
      if (page) {
        if (result.cc.list.length) {
          result.cc.list.forEach(item => {
            const itemInfo = {
              ...item,
              value: item.peerId,
              label: item.name
            };
            receiverObj.children.push(itemInfo);
          });
          array.push(receiverObj);
          if (showSelect) {
            this.$emit('changeSourceList', result.cc.list);
          }
        } else {
          receiverObj.disabled = true;
        }
        // pp list
        const ppObj = {};
        ppObj.value = 'Producer';
        ppObj.label = 'Producer';
        if (result.pps && result.pps.length) {
          ppObj.children = this.dealPPList(result.pps);
        } else {
          ppObj.disabled = true;
        }
        array.push(ppObj);
      } else {
        array = result;
      }
      this.receiverList = array;
    },
    dealPPList(list) {
      const array = [];
      list.forEach(item => {
        item.pageInfo.list.forEach(info => {
          this.State.slotList.push(info.rids);
          const ppObj = {};
          ppObj.value = info.receiverId;
          ppObj.label = info.name;
          ppObj.userInfo = item.user;
          ppObj.children = info.rids.map((slotId, index) => {
            return {
              value: slotId,
              label: `Slot${index + 1}`
            };
          });
          array.push(ppObj);
        });
      });
      return array;
    },
    callbackByLiveSource({
      type,
      rid,
      from,
      val,
      filter
    }) {
      // if (type == 'getReceiverList') {
      //   this.getRList(from)
      // }
      if (type == 'getReceiverList' && !filter) {
        this.getRList(filter);
      } else if (type == 'getReceiverList' && filter) {
        if (this.getRListTimer) clearTimeout(this.getRListTimer);
        this.getRListTimer = setTimeout(() => {
          this.getRList(filter, val);
        }, 500);
      }
      if (type == 'changeSource') {
        if (typeof rid === 'string') {
          this.selectRid = rid;
        } else {
          this.selectRid = rid[1];
        }
      }
    },
    getRList(filter, val) {
      if (!filter) {
        this.getReceiverParams = {
          pageNum: 1,
          pageSize: 400,
          living: true,
          offline: false,
          online: true,
          queryCollaborate: true
        };
      } else {
        this.getReceiverParams = {
          living: true,
          offline: false,
          online: true,
          queryCollaborate: true,
          condition: val
        };
      }
      this.axios.post('/partyline-backend/receiver/v3/page', this.getReceiverParams).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.formatRList(result, false, 'page');
          this.$emit('changeRList', result);
        }
      });
    },
    isMainwindowReturnStyle(val, index) {
      if (this.outputSourceType == 'Pbp') {
        const rtilCodes = this.outputRtilList.map(v => v.rtilCode);
        if (rtilCodes.includes(val)) {
          return this.mainWindowPositionList[val];
        }
      }
      if (this.State.isVertical && this.rtilList.length == 2 && index == 0) {
        return {
          'grid-column': '1 / span 2',
          'grid-row': '1 / span 2'
        };
      }
      if (val == 'mainWindow' || val == this.outputRtilCode && val != 0) {
        return this.mainWindowPosition;
      }
    },
    setItemGridWidth(row, column, yStart, xStart, ySpan, xSpan) {
      const width = 100 / column;

      // 设置每个棋盘格的宽高
      Object.keys(this.layoutStyle).forEach(key => {
        switch (key) {
          case 'grid-template-columns':
            // 从第一行开始到第几行设置宽度为多少
            this.$set(this.layoutStyle, key, `repeat(${column}, ${width}%)`);
            break;
        }
      });
      // 设置mainWindow在棋盘格的位置
      Object.keys(this.mainWindowPosition).forEach(key => {
        switch (key) {
          case 'grid-column':
            // 从第一行开始到第几行设置宽度为多少
            this.$set(this.mainWindowPosition, key, `${xStart || 2} / span ${xSpan || 2}`);
            break;
          case 'grid-row':
            // 从第一列开始到第几列设置高度为多少
            this.$set(this.mainWindowPosition, key, `${yStart || 1} / span ${ySpan || 2}`);
            break;
        }
      });
    },
    changePbpView(list) {
      if (list <= 2) {
        this.row = 2;
        this.column = 2;
        this.outputRtilList.forEach(val => {
          val.x = val.position;
          val.y = 1;
        });
        // 1: 1,1
        // 2: 2,1
      } else if (list > 2 && list <= 4) {
        this.row = 2;
        this.column = 3;
        this.outputRtilList.forEach(val => {
          val.x = val.position + 1;
          val.y = 1;
        });
        // 1: 2,1
        // 2: 3,1
      } else if (list > 4 && list <= 6) {
        this.row = 2;
        this.column = 4;
        this.outputRtilList.forEach(val => {
          val.x = val.position + 1;
          val.y = 1;
        });
        // 1: 2,1
        // 2: 3,1
      } else if (list > 6 && list <= 10) {
        this.row = 3;
        this.column = 4;
        this.outputRtilList.forEach(val => {
          val.x = val.position + 1;
          val.y = 1;
        });
        // 1: 2,1
        // 2: 3,1
      } else if (list > 10 && list <= 14) {
        this.row = 4;
        this.column = 4;
        this.outputRtilList.forEach(val => {
          val.x = val.position + 1;
          val.y = 2;
        });
        // 1: 2,2
        // 2: 3,2
      } else if (list > 14 && list <= 18) {
        this.row = 5;
        this.column = 4;
        this.outputRtilList.forEach(val => {
          val.x = val.position + 1;
          val.y = 2;
        });
        // 1: 2,2
        // 2: 3,2
      } else if (list > 18 && list <= 22) {
        this.row = 4;
        this.column = 6;
        this.outputRtilList.forEach(val => {
          val.x = val.position + 2;
          val.y = 2;
        });
        // 1: 3,2
        // 2: 4,2
      } else if (list > 22 && list <= 28) {
        this.row = 5;
        this.column = 6;
        this.outputRtilList.forEach(val => {
          val.x = val.position + 2;
          val.y = 2;
        });
        // 1: 3,2
        // 2: 4,2
      } else if (list > 28) {
        this.row = 6;
        this.column = 6;
        this.outputRtilList.forEach(val => {
          val.x = val.position + 2;
          val.y = 2;
        });
        // 1: 3,2
        // 2: 4,2
      }

      this.outputRtilList.forEach(val => {
        this.mainWindowPositionList[val.rtilCode] = {
          'grid-column': `${val.x} / span 1`,
          'grid-row': `${val.y} / span 2`
        };
      });
      const width = 100 / this.column;

      // 设置每个棋盘格的宽高
      Object.keys(this.layoutStyle).forEach(key => {
        switch (key) {
          case 'grid-template-columns':
            // 从第一行开始到第几行设置宽度为多少
            this.$set(this.layoutStyle, key, `repeat(${this.column}, ${width}%)`);
            break;
        }
      });
    },
    changeView(list) {
      // 如果pip：1-2人，则canvas的宽16+32，高18 (2x3)
      // 如果pip：3-4人，则canvas的宽16+32+16，高18 (2x4)
      // 如果pip：5-8人，则canvas的宽16+32+16，高9+18 (3x4)
      // 如果pip：9-12人，则canvas的宽16+32+16，高9+18+9 (4x4)
      // 如果pip：13-16人，则canvas的宽16+32+16，高9+18+9+9 (5x4)
      this.offsetMainWindowY = null;
      this.offsetMainWindowX = null;
      this.spanMainWindowY = 2;
      this.spanMainWindowX = 2;
      if (list == 1) {
        this.row = 2;
        this.column = 2;
        this.offsetMainWindowY = 1;
        this.offsetMainWindowX = 1;
      } else if (list > 1 && list <= 3) {
        this.row = 2;
        this.column = 3;
      } else if (list > 3 && list <= 5) {
        this.row = 2;
        this.column = 4;
      } else if (list > 5 && list <= 9) {
        this.row = 3;
        this.column = 4;
      } else if (list > 9 && list <= 13) {
        this.row = 4;
        this.column = 4;
        this.offsetMainWindowY = 2;
      } else if (list > 13 && list <= 17) {
        this.row = 5;
        this.column = 4;
        this.offsetMainWindowY = 2;
      } else if (list > 17 && list <= 21) {
        this.row = 4;
        this.column = 6;
        this.offsetMainWindowY = 2;
        this.offsetMainWindowX = 3;
      } else if (list > 21 && list <= 27) {
        this.row = 5;
        this.column = 6;
        this.offsetMainWindowY = 2;
        this.offsetMainWindowX = 3;
      } else if (list > 27) {
        this.row = 6;
        this.column = 6;
        this.offsetMainWindowY = 2;
        this.offsetMainWindowX = 3;
      }
    },
    changeVerticalVal(list) {
      // 如果pip：1人， 则canvas的宽32.高18 (2x2)
      // 如果pip：1-2人，则canvas的宽16+32，高18 (2x3)
      // 如果pip：3-4人，则canvas的宽16+32+16，高18 (2x4)
      // 如果pip：5-8人，则canvas的宽16+32+16，高9+18 (3x4)
      // 如果pip：9-12人，则canvas的宽16+32+16，高9+18+9 (4x4)
      // 如果pip：13-16人，则canvas的宽16+32+16，高9+18+9+9 (5x4)
      this.offsetMainWindowY = null;
      this.offsetMainWindowX = null;
      this.spanMainWindowY = null;
      this.spanMainWindowX = null;
      if (list == 1) {
        this.row = 2;
        this.column = 2;
        this.offsetMainWindowY = 1;
        this.offsetMainWindowX = 1;
      } else if (list == 2) {
        this.row = 2;
        this.column = 2;
        this.offsetMainWindowY = 3;
        this.offsetMainWindowX = 1;
      } else if (list > 2 && list <= 5) {
        this.row = 3;
        this.column = 2;
        this.offsetMainWindowY = 2;
        this.offsetMainWindowX = 1;
      } else if (list > 5 && list <= 9) {
        this.row = 4;
        this.column = 2;
        this.offsetMainWindowY = 3;
        this.offsetMainWindowX = 1;
      } else if (list > 9 && list <= 13) {
        this.row = 4;
        this.column = 3;
        this.offsetMainWindowY = 3;
        this.offsetMainWindowX = 1;
        this.spanMainWindowY = 2;
        this.spanMainWindowX = 3;
      } else if (list > 13 && list <= 16) {
        this.row = 5;
        this.column = 3;
        this.offsetMainWindowY = 4;
        this.offsetMainWindowX = 1;
        this.spanMainWindowY = 2;
        this.spanMainWindowX = 3;
      } else if (list > 16 && list <= 19) {
        this.row = 5;
        this.column = 3;
        this.offsetMainWindowY = 4;
        this.offsetMainWindowX = 1;
        this.spanMainWindowY = 2;
        this.spanMainWindowX = 3;
      } else if (list > 19 && list <= 28) {
        this.row = 6;
        this.column = 4;
        this.offsetMainWindowY = 4;
        this.offsetMainWindowX = 1;
        this.spanMainWindowY = 2;
        this.spanMainWindowX = 4;
      } else {
        this.row = 6;
        this.column = 4;
        this.offsetMainWindowY = 5;
        this.offsetMainWindowX = 1;
        this.spanMainWindowY = 2;
        this.spanMainWindowX = 4;
      }
    },
    returnTitle(val) {
      if (val == this.outputRtilCode) {
        return '';
      } else {
        return this.streamInfo[val] ? this.streamInfo[val].tid : '';
      }
    },
    operateCallback(val) {
      this.$emit('callback', val);
    },
    changeCanvasView() {
      const logoWidth = document.getElementById('logoConfig') && !this.State.isVertical ? document.getElementById('logoConfig').clientWidth : 0;
      let width = document.getElementsByClassName('pipList')[0].clientWidth - logoWidth * 2 - 25 * 2; // 25留作间距,乘以2是因为盒子是剧中的要把两边的空域部分都流出来
      let height = document.getElementsByClassName('pipList')[0].clientHeight - 25; // 25留作间距
      const percent = 16 * this.column / (9 * this.row);
      if (this.fullScreen && this.$route.name != 'kioskParticipate') {
        width = document.getElementsByClassName('participateList')[0].clientWidth - logoWidth - 40; // 40留作间距
        height = document.getElementsByClassName('participateList')[0].clientHeight - 40; // 40留作间距
      }

      if (width / height > percent) {
        // 宽度足够，高度不够， 以高度计算最大宽度
        const maxWidth = percent * height;
        document.getElementsByClassName('listBox')[0].style.width = maxWidth + 'px';
        document.getElementById('containerCanvas').style.width = maxWidth + 'px';
      } else {
        if (this.uploadLogo) {
          document.getElementsByClassName('listBox')[0].style.width = width - 10 - 40 + 'px';
          document.getElementById('containerCanvas').style.width = width - 10 - 40 + 'px';
        } else {
          if (this.showChatMessage) {
            document.getElementsByClassName('listBox')[0].style.width = '100%';
            document.getElementById('containerCanvas').style.width = '100%';
          } else {
            if (!this.State.isVertical) {
              document.getElementsByClassName('listBox')[0].style.width = `calc(90vw - ${logoWidth + 5 + 40}px)`;
              document.getElementById('containerCanvas').style.width = `calc(90vw - ${logoWidth + 5 + 40}px)`;
            }
          }
        }
      }
    },
    changeVerticalCanvas() {
      const width = document.getElementById('containerCanvas').clientWidth;
      const height = document.getElementById('containerCanvas').clientHeight;
      const availableHeight = document.getElementsByClassName('pipList')[0].clientHeight;
      const availableWidth = document.getElementsByClassName('pipList')[0].clientWidth;
      const newWidth = width * availableHeight / height;
      if (availableWidth / availableHeight < width / height) {
        document.getElementsByClassName('listBox')[0].style.width = availableWidth - 20 + 'px';
        document.getElementById('containerCanvas').style.width = availableWidth - 20 + 'px';
      } else {
        document.getElementsByClassName('listBox')[0].style.width = newWidth + 'px';
        document.getElementById('containerCanvas').style.width = newWidth + 'px';
      }
    },
    moveParty(status, val) {
      this.$emit('callback', {
        type: 'moveParty',
        id: val,
        status: status,
        sign: 'batch'
      });
    }
  }
};